export enum QUERY_KEY {
  DAOS = 'QUERY:DAOS',
  DAO = 'QUERY:DAO',
  RECENT_DAOS = 'QUERY:RECENT_DAOS',
  PROPOSALS = 'QUERY:PROPOSALS',
  RECENT_PROPOSALS = 'QUERY:RECENT_PROPOSALS',
  PROPOSAL = 'QUERY:PROPOSAL',
  VOTERS = 'QUERY:VOTERS',
  PROPOSAL_VOTES = 'QUERY:PROPOSAL_VOTES',
  PROPOSAL_VOTE = 'QUERY:PROPOSAL_VOTES',
  COMMUNITY_POOL = 'QUERY:COMMUNITY_POOL',
  NATIVE_BALANCE = 'QUERY:NATIVE_BALANCE',
  CW20_TOKEN_BALANCE = 'QUERY:CW20_TOKEN_BALANCE',
  CW20_TOKEN_QUERY = 'QUERY:CW20_TOKEN_QUERY',
  CW721_NUM_TOKENS = 'QUERY:CW721_NUM_TOKENS',
  CW721_CONTRACT_INFO = 'QUERY:CW721_CONTRACT_INFO',
  CW721_TOKENS = 'QUERY:CW721_TOKENS',
  CW3_LIST_VOTERS = 'QUERY:CW3_LIST_VOTERS',
  TOKEN_STAKING_AMOUNT = 'QUERY:TOKEN_STAKING_AMOUNT',
  NFT_STAKING_AMOUNT = 'QUERY:NFT_STAKING_AMOUNT',
  NFT_STAKING = 'QUERY:NFT_STAKING',
  VOTING_POWER = 'QUERY:VOTING_POWER',
  CLAIMS = 'QUERY:CLAIMS',
  RELEASABLE_CLAIMS = 'QUERY:RELEASABLE_CLAIMS',
  BLOCK_HEIGHT = 'QUERY:BLOCK_HEIGHT',
  CUSTOM_ASSET_WHITELIST = 'QUERY:CUSTOM_ASSET_WHITELIST',
  GLOBAL_ASSET_WHITELIST = 'QUERY:GLOBAL_ASSET_WHITELIST',
  CW20_TREASURY = 'QUERY:CW20_TREASURY',
  NFT_TREASURY = 'QUERY:NFT_TREASURY',
  TXS = 'QUERY:TXS',
  CODE_IDS = 'QUERY:CODE_IDS',
  TOKEN_BALANCE = 'QUERY:TOKEN_BALANCE',
  CW20_TOKENS = 'QUERY:CW20_TOKENS',
  IBC_TOKENS = 'QUERY:IBC_TOKENS',
  MULTISIG_MEMBERS = 'QUERY:MULTISIG_MEMBERS',
  CONTRACT_INFO = 'QUERY:CONTRACT_INFO',
  DAO_ASSETS = 'QUERY:DAO_ASSETS',
  DAO_NFTS = 'QUERY:DAO_NFTS',
  CUSTOM_NFT_WHITELIST = 'QUERY:CUSTOM_NFT_WHITELIST',
  GLOBAL_NFT_WHITELIST = 'QUERY:GLOBAL_NFT_WHITELIST',
  MY_NFTS = 'QUERY:MY_NFTS',
  NFT_INFO = 'QUERY:NFT_INFO',
  NFTS = 'QUERY:NFTS',
  DELEGATIONS = 'QUERY:DELEGATIONS',
  NFT_MINTER = 'QUERY:NFT_MINTER',
  ESTIMATED_FEE = 'QUERY:ESTIMATED_FEE',
  MY_DAO_REWARDS = 'QUERY:MY_DAO_REWARDS',
  ASSET_INFO = 'QUERY:ASSET_INFO',
  MINIMUM_ELIGIBLE_WEIGHT = 'QUERY:MINIMUM_ELIGIBLE_WEIGHT',
  PRICES_OF_LIQUID_ASSETS = 'QUERY:PRICES_OF_LIQUID_ASSETS',
  STAKED_NFTS = 'QUERY:STAKED_NFTS',
  ASSET_BALANCE = 'QUERY:ASSET_BALANCE',
  ASSETS_INFO = 'QUERY:ASSETS_INFO',
}
